<template>
  <div class="approver-error">
    <div class="body">
      <img
        class="logo-img"
        src="@/assets/img/app-transit/yoov_logo_2.png"
        alt="logo"
      />

      <div class="page-not-found">
        <p class="tips">{{ $t('errorPage.401Tip') }}</p>
        <Button type="primary" class="back-btn login-out" @click="loginOut">
          {{ $t('appTransit.loginOut') }}
        </Button>
        <a href="javascript: void(0);" class="back-btn-a" @click="onSwitch">
          {{ $t('subscribe.switchTeam') }}
        </a>
      </div>
    </div>

    <SwitchTeamModal ref="switchTeamModalRef" />
  </div>
</template>

<script>
import { AuthManage } from '@/plugins/auth';
import SwitchTeamModal from '@/components/SwitchTeamModal.vue';
export default {
  components: {
    SwitchTeamModal
  },
  computed: {
    type() {
      return this.$route.query.type;
    }
  },
  methods: {
    loginOut() {
      this.$router.replace('/');
      setTimeout(() => {
        AuthManage.logoutFn();
      }, 50);
    },
    onSwitch() {
      this.$refs.switchTeamModalRef.show();
    }
  }
};
</script>
<style lang="less" scoped>
.body {
  height: 100vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.logo {
  text-align: center;
}

.tips {
  font-size: 20px;
  margin: 50px 0 100px 0;
  font-weight: bold;
}

.back-btn {
  height: 38px;
  font-weight: bold;
  background-color: #5fc5ce;
  border-color: #5fc5ce;
}

.page-not-found {
  width: 300px;
  margin: 0 auto;

  .title {
    font-size: 32px;
    font-weight: bold;
    margin-top: 50px;
  }

  .tips {
    font-weight: normal;
    margin-top: 20px;
    font-size: 18px;
  }

  .login-out {
    width: 300px;
  }

  .back-btn-a {
    display: block;
    margin-top: 30px;
  }
}
</style>
